// Checkout offer configuration
// Flip these flags to change what's included or forced at checkout.
// Changes here take effect after a bundle rebuild — no other files need touching.
export const CHECKOUT_CONFIG = {
  // true  → standard acrylics are forced/locked on 0% finance orders (plate toggle hidden)
  // false → customer sees the normal Yes/No plate toggle regardless of finance type
  includeAcrylicsOnZeroPercentFinance: false,
} as const;
